var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserQueue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 62,
    viewBox: "0 0 189 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30C38.2875 30 45 23.2875 45 15C45 6.7125 38.2875 0 30 0C21.7125 0 15 6.7125 15 15C15 23.2875 21.7125 30 30 30ZM30 37.5C19.9875 37.5 0 42.525 0 52.5V60H60V52.5C60 42.525 40.0125 37.5 30 37.5Z",
    fill: "#2B3E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8334 22.333H87.3334L95.6667 33.9997L87.3334 45.6663H94.8334L103.167 33.9997L94.8334 22.333Z",
    fill: "#FFA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1667 22.333H75.6667L84.0001 33.9997L75.6667 45.6663H83.1667L91.5001 33.9997L83.1667 22.333Z",
    fill: "#2B3E5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.5 48.75L151.75 37.725C150.287 37.575 149.2 37.5 148 37.5C137.987 37.5 118 42.525 118 52.5V60H151.75L140.5 48.75ZM148 30C156.287 30 163 23.2875 163 15C163 6.7125 156.287 0 148 0C139.712 0 133 6.7125 133 15C133 23.2875 139.712 30 148 30Z",
    fill: "#FFA000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.839 62L152 48.875L157.18 43.5875L164.839 51.3875L183.82 32L189 37.2875L164.839 62Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserQueue);
export default __webpack_public_path__ + "static/media/userQueue.b668bd017f07abfe387cb3ebb84bb45f.svg";
export { ForwardRef as ReactComponent };